import { getLabel } from "../labels";

export function getMonthsLabels() {
    const months = [
        getLabel('general.months.jan'),
        getLabel('general.months.feb'),
        getLabel('general.months.mar'),
        getLabel('general.months.apr'),
        getLabel('general.months.may'),
        getLabel('general.months.jun'),
        getLabel('general.months.jul'),
        getLabel('general.months.aug'),
        getLabel('general.months.sep'),
        getLabel('general.months.oct'),
        getLabel('general.months.nov'),
        getLabel('general.months.dec'),
    ];

    return months;
}
